import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../extras/Table";
import { getSalonRequest } from "../../../redux/slice/salonRequestSlice";
import image from "../../../assets/images/image.png";
import { openDialog } from "../../../redux/slice/dialogueSlice";
import SalonRequestDialogue from "./SalonRequestDialogue";
import { IconEye } from "@tabler/icons-react";

export const SalonRequest = () => {
  const { salonRequest } = useSelector((state) => state.salonRequest);
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);

  const [data, setData] = useState();
  const dispatch = useDispatch();

  console.log("SalonRequest", salonRequest);

  useEffect(() => {
    dispatch(getSalonRequest());
  }, [dispatch]);

  useEffect(() => {
    setData(salonRequest);
  });

  const salonRequestTable = [
    {
      Header: "No",
      Cell: ({ index }) => <span>{index + 1}</span>,
    },
    {
      Header: "Image",
      Cell: ({ row }) => (
        <div className="userProfile">
          <img
            src={row && row.image}
            alt="f"
            className="cursor-pointer"
            style={{ height: "50px", width: "50px", overflow: "hidden" }}
            height={`100%`}
            
          />
        </div>
      ),
    },
    {
      Header: "Name",
      Cell: ({ row }) => <span className="text-capitalize">{row?.name}</span>,
    },

    {
      Header: "Email",
      Cell: ({ row }) => <span className="text-capitalize">{row?.email}</span>,
    },

    {
      Header: "About",
      Cell: ({ row }) => <span className="text-capitalize">{row?.about}</span>,
    },

    {
      Header: "Info",
      Cell: ({ row }) => (
        <div className="action-button">
          <button
            className="btn btn-sm"
            onClick={() =>
              dispatch(openDialog({ type: "salonRequest", data: row }))
            }
          >
            <IconEye className="text-secondary" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
    <div className="userPage">
        <div className="user-table mb-3">
      <div className="user-table-top">
          <div className=" d-flex justify-content-between align-items-center w-100 ">
            <div className="w-100">
              <h5
                className="main-title">
                Saloon Requests
              </h5>
            </div>
           
          </div>
        </div>
      <Table data={data} mapData={salonRequestTable} />
        </div>
    </div>
      {dialogueType == "salonRequest" && <SalonRequestDialogue />}
    </>
  );
};
